import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import { getPackagesAttributes } from './utils';

import type {
  ConductorCreativeFlightsPackagesPricedFields,
  CreativeFlightsPackagesPriced,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getPackagesPricedCreative = (
  fields: ConductorCreativeFlightsPackagesPricedFields,
): CreativeFlightsPackagesPriced => {
  const {
    appIndex,
    brandedWrapperColour,
    ctaCopy = null,
    customDestination = null,
    customPackageAttribute1,
    customPackageAttribute2,
    customPackageAttribute3,
    customPackageAttribute4,
    destination,
    headline = null,
    heroImage,
    packageAttributes,
    partnerLogo,
    partnerName,
    pioAgencyName,
    pioPartnerName,
    pricePerPerson,
    redirectUrl,
    savedMoney,
    showTermsAndConditions,
    splitTestId,
    sponsoredTargetDestination,
    sponsoredText,
    strevdaId,
    totalPrice,
    valueProposition,
    wrapperTextColour,
  } = fields;

  const customAttributes = [
    customPackageAttribute1,
    customPackageAttribute2,
    customPackageAttribute3,
    customPackageAttribute4,
  ];

  return {
    appIndex,
    ctaCopy,
    headline,
    heroImage,
    customDestination,
    destination,
    partnerLogo,
    partnerName,
    pricePerPerson,
    redirectUrl,
    strevdaId,
    valueProposition,
    sponsoredTargetDestination,
    sponsoredText,
    savedMoney,
    totalPrice,
    brandedWrapperColour,
    packageAttributes: getPackagesAttributes(packageAttributes, customAttributes),
    wrapperTextColour,
    showTermsAndConditions: showTermsAndConditions === 'true',
    format: ADVERT_FORMAT_TYPES.PACKAGES_PRICED,
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
